export const OAUTH_API_BASE_URL = 'https://oauth.marqii.com'
export const IMPERSONATION_COOKIE_NAME = 'IMPERSONATING_AS'
export const IMPERSONATION_COOKIE_SETTINGS = {
  domain: 'app.marqii.com',
  secure: true,
  path: '/',
}
export const MARQII_COGNITO_CLIENT_ID = 'MARQII_COGNITO_CLIENT_ID'
export const MARQII_COGNITO_COOKIE_SETTINGS = IMPERSONATION_COOKIE_SETTINGS

// hosted auth urls
export const HOSTED_UI_DOMAIN = 'auth.marqii.com'
export const COGNITO_SCOPES = [
  'email',
  'profile',
  'openid',
  'phone',
  'aws.cognito.signin.user.admin',
]
// custom client ids
export const LINKEDEATS_COGNITO_CLIENT_ID = '1noq6ac4rjffbf3s0d2uc4gr26'
export const LINKEDEATS_REDIRECT_SIGN_IN_PROD = 'https://app.marqii.com/sso/linkedeats/callback'
export const LINKEDEATS_REDIRECT_SIGN_OUT_PROD = 'https://vdctech.us.auth0.com/oidc/logout'

const _SSO_ONLY_CLIENT_IDS = [LINKEDEATS_COGNITO_CLIENT_ID]

export const SSO_OAUTH_CREDS = new Map<
  (typeof _SSO_ONLY_CLIENT_IDS)[number],
  { signInRedirectUrl: string; signOutUrl: string }
>([
  [
    LINKEDEATS_COGNITO_CLIENT_ID,
    {
      signInRedirectUrl: LINKEDEATS_REDIRECT_SIGN_IN_PROD,
      signOutUrl: LINKEDEATS_REDIRECT_SIGN_OUT_PROD,
    },
  ],
])
